// Sorteringskomparator för tabeller.
// Hanterar datum (DD-MM-YYYY och YYYY-MM-DD), numeriska värden och strängar.
const parseDate = (value) => {
  if (!value) return null;

  // Format 1: YYYY-MM-DD (med ev. tidssuffix)
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
    const d = new Date(value.substring(0, 10));
    return isNaN(d) ? null : d;
  }

  // Format 2: DD-MM-YYYY (med ev. tidssuffix)
  if (/^\d{2}-\d{2}-\d{4}/.test(value)) {
    const parts = value.substring(0, 10).split('-');
    const d = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    return isNaN(d) ? null : d;
  }

  return null;
};

export const compareRows = (a, b, key, direction) => {
  const aVal = a[key];
  const bVal = b[key];

  const aDate = parseDate(aVal);
  const bDate = parseDate(bVal);
  if (aDate && bDate) {
    const cmp = aDate - bDate;
    return direction === 'asc' ? cmp : -cmp;
  }

  const aNum = Number(aVal);
  const bNum = Number(bVal);
  if (!isNaN(aNum) && !isNaN(bNum)) {
    const cmp = aNum - bNum;
    return direction === 'asc' ? cmp : -cmp;
  }

  const aStr = String(aVal ?? '').toLowerCase();
  const bStr = String(bVal ?? '').toLowerCase();
  let cmp;
  if (aStr < bStr) cmp = -1;
  else if (aStr > bStr) cmp = 1;
  else cmp = 0;
  return direction === 'asc' ? cmp : -cmp;
};
